import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { DataResponse, GoalResponseDataSchema } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof GoalResponseDataSchema>>

export const getGoalQueryKey = (id: string | null) => ["goals", id]

export const goalQuery = (id: string | null) => {
  return queryOptions({
    queryKey: getGoalQueryKey(id),
    queryFn: async () => {
      if (!id) {
        return null
      }

      const response = await axios.get<Response>(`/goals/${id}`)
      return response.data.data
    },
    staleTime: 1000 * 60 * 2,
  })
}
